import React from "react";
import { Navigate } from "react-router-dom";
import { useAppContext } from "../../Context/AppContext";
import { baseRoute } from "../../Helper";
import { WEB_ROUTES } from "../../constants";
import _ from "lodash";

function ProtectedRoute({ children }) {

    const { isLoggedIn } = useAppContext();

    return (
        _.isUndefined(isLoggedIn) ? <></> :
            !isLoggedIn ? <Navigate to={baseRoute(WEB_ROUTES.ACCOUNT)} replace={true} /> : children
    );
}

export default ProtectedRoute;